module.exports = __webpack_public_path__ + "static/media/mark-no-show.77885b51.svg";